import { render, staticRenderFns } from "./cookie-categories-tab.vue?vue&type=template&id=1ead22d3"
import script from "./cookie-categories-tab.vue?vue&type=script&lang=js"
export * from "./cookie-categories-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports